import styled               from 'styled-components';

import { ButtonVariants   } from 'src/components/common/button';
import { CheckboxVariants } from 'src/components/common/checkbox';

import { cssFlexColumn,
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors,
         cssFlexRow       } from 'src/providers/theme/shared';



type AcceptDialogLookAndFeel = {
  paddings: number[];

  captionTypo: Typo;
  captionColor: string;

  gap: number;
  checkGap: number;
  actionsGap: number;

  checkboxVariant: CheckboxVariants;

  cancelButtonVariant: ButtonVariants;
  acceptButtonVariant: ButtonVariants;
}

const acceptdialog_light: AcceptDialogLookAndFeel = {
  paddings: [28, 20],

  captionTypo: themeTypos.GRTSKREG_W600_S18_LH24,
  captionColor: themeColors.AccentBlue2,

  gap: 32,
  checkGap: 28,
  actionsGap: 16,

  checkboxVariant: 'h24bluelink',

  cancelButtonVariant: 'h48blueoutline',
  acceptButtonVariant: 'h48bluefill',
}

export type AcceptDialogVariants = 'light';

export const acceptdialog_variants: Map<AcceptDialogVariants, AcceptDialogLookAndFeel> = 
  new Map<AcceptDialogVariants, AcceptDialogLookAndFeel>([
    ['light', acceptdialog_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: AcceptDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap}px;

  padding: ${(args) => args.lookAndFeel.paddings[0]}px ${(args) => args.lookAndFeel.paddings[1]}px;
`

export const Caption = styled.div<{
  lookAndFeel: AcceptDialogLookAndFeel
}>`
  text-align: center;

  ${(args) => typoAsCSS(args.lookAndFeel.captionTypo)};
  color: ${(args) => args.lookAndFeel.captionColor};
`

export const Checkboxes = styled.div<{
  lookAndFeel: AcceptDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.checkGap}px;
`

export const Actions = styled.div<{
  lookAndFeel: AcceptDialogLookAndFeel
}>`
  ${cssFlexRow};
  gap: ${(args) => args.lookAndFeel.actionsGap}px;
`
